import { Box, Container } from "@repo/ui/core";
import type { ReactNode } from "react";
import styles from "@styles/site.module.css";

type SectionProps = {
  children: ReactNode;
  tight?: boolean;
  hairline?: boolean;
  id?: string;
};

export function Section({ children, tight, hairline, id }: SectionProps) {
  return (
    <Box
      component="section"
      id={id}
      className={`${tight ? styles.sectionTight : styles.section} ${hairline ? styles.hairlineTop : ""}`}
    >
      <Container size="xl">{children}</Container>
    </Box>
  );
}
